import React from 'react';
import Style from './formDivider.module.css';
import { InputLabel, InputSublabel } from '@weezevent/nacre';

export default function FormDivider({ field, label }) {
    return (
        <div className={Style['divider']}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
        </div>
    );
}
